import React, { PropsWithChildren } from 'react';

export function Item({
  header,
  description,
  children,
}: PropsWithChildren<{ header: string; description: string | number }>) {
  return (
    <div className="item">
      <div className={'content'}>
        <div className={'header'}>
          {header}
          <span style={{ paddingLeft: '10px' }}>{description}</span>
          {children}
        </div>
      </div>
    </div>
  );
}
